import { FieldConfig } from "../../common/forms/Interfaces";

const config = {
  password: {
    label: "New Password",
    placeholder: "Enter new password",
    validationRules: [
      { required: true, message: "Please input new password!" },
      { min: 8, message: "The field must be at least 8 characters!" },
    ],
    type: "password",
  },
  password_confirmation: {
    type: "password",
    label: "Repeat Password",
    placeholder: "Repeat new password",
    validationRules: [
      { required: true, message: "Please repeat new password!" },
      { min: 8, message: "The field must be at least 8 characters!" },
      ({ getFieldValue }) => ({
        validator(rule, value) {
          if (!value || getFieldValue("password") === value) {
            return Promise.resolve();
          }

          return Promise.reject(
            "The two passwords that you entered do not match!"
          );
        },
      }),
    ],
  },
} as { [key: string]: FieldConfig };

export default config;
